import { render } from "./App.vue?vue&type=template&id=17566b27"
const script = {}

import "./App.vue?vue&type=style&index=0&id=17566b27&lang=css"

import exportComponent from "d:\\projekty\\www\\cdif3com\\rental\\source\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__